"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerItemData = exports.registerAll = exports.get = exports.dataListScrolls = exports.dataListPotions = exports.dataListSpawnable = exports.ERogueItemGroup = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var onceOnly_sidecar_1 = require("../../../lib/onceOnly-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var ERogueItemGroup;
(function (ERogueItemGroup) {
    ERogueItemGroup[ERogueItemGroup["none"] = 0] = "none";
    ERogueItemGroup[ERogueItemGroup["gold"] = 1] = "gold";
    ERogueItemGroup[ERogueItemGroup["scroll"] = 2] = "scroll";
    ERogueItemGroup[ERogueItemGroup["potion"] = 3] = "potion";
})(ERogueItemGroup = exports.ERogueItemGroup || (exports.ERogueItemGroup = {}));
var _default = {
    group: ERogueItemGroup.none,
    type: 'default',
    name: 'default',
    description: 'default',
    char: '!',
    sprite: rogueMonofont_sidecar_1.rogueMonofont.getSprite('!'),
    sprite2: null,
    color: rogueDef_sidecar_1.rogueDef.colors.light,
    spawnChance: 1,
};
var dataType = 'items';
var dataList = [];
exports.dataListSpawnable = [];
exports.dataListPotions = [];
exports.dataListScrolls = [];
var dataMapType = {};
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
};
exports.get = get;
var registerAll = function () {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    (0, exports.registerItemData)({
        group: ERogueItemGroup.gold,
        type: 'gold',
        description: 'A pile of gold',
        name: 'gold',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.potion,
        type: 'potion-fire',
        description: 'A potion of fire',
        name: 'potion of fire',
        color: rogueDef_sidecar_1.rogueDef.colors.orange,
        sprite: sprites_sidecar_1.sprites.rogue05,
        sprite2: sprites_sidecar_1.sprites.rogue04,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.potion,
        type: 'potion-heal',
        description: 'A potion of health',
        name: 'potion of health',
        color: rogueDef_sidecar_1.rogueDef.colors.red,
        sprite: sprites_sidecar_1.sprites.rogue05,
        sprite2: sprites_sidecar_1.sprites.rogue04,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.scroll,
        type: 'scroll-teleport',
        description: 'A scroll of teleport',
        name: 'scroll of teleport',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue02,
    });
};
exports.registerAll = registerAll;
var registerItemData = function (data) {
    assert_sidecar_1.assert.notNil(data.type);
    if (!data.char) {
        data.char = data.type;
    }
    if (!data.name) {
        data.name = '' + data.type;
    }
    if (!data.sprite) {
        data.sprite = rogueMonofont_sidecar_1.rogueMonofont.getSprite(data.char);
    }
    var merged = entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
    if (merged.group === ERogueItemGroup.potion) {
        exports.dataListPotions.push(merged);
    }
    if (merged.group === ERogueItemGroup.scroll) {
        exports.dataListScrolls.push(merged);
    }
    if (merged.spawnChance > 0) {
        exports.dataListSpawnable.push(merged);
    }
};
exports.registerItemData = registerItemData;
